import packageJson from "../../package.json";

export const basepath = packageJson.homepage;

enum Path {
  ROOT = "/",

  ACTIVITY = "/activity",
  AUTH_CALLBACK = "/auth/callback",
  BILLING = "/billing",
  COMPANY = "/company",
  DASHBOARD = "/dashboard",
  DEAL = "/deals",
  EMAIL_OUTBOX = "/email-outbox",
  EMAIL_UNSUBSCRIBE = "/email-unsubscribe",
  FILES = "/files",
  FORGOT_PASSWORD = "/forgot-password",
  LOGIN = "/login",
  MANAGE_USER_ACCESS = "/sso-access",
  MAP = "/map",
  NOTIFICATIONS = "/notifications",
  ONBOARDING = "/onboarding",
  PEOPLE = "/people",
  REGISTER = "/register",
  REPORTS = "/reports",
  RESOURCES = "/resources",
  RESET_PASSWORD = "/reset-password",
  ROUTE = "/route",
  SETTINGS = "/settings",
  SSO_LOGIN = "/ssologin",
  WEB_1 = "/web1",
}

export default Path;
